module.exports = __webpack_public_path__ + "img/Galileo-logo.6274353.webp";